import React from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { SubtractCircleIcons } from '../../../../icons/icons';
import { formatItemIndex } from '../functions';
import { JobTitleCardProps } from '../interfaces';

export const JobTitleCard = ({
  jobTitle,
  index,
  currentPage,
  itemsPerPage,
  onDelete,
}: JobTitleCardProps) => {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '6px',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        p: 1.5,
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'action.active',
          '& .delete-btn': {
            opacity: 1,
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0, flex: 1, mr: 1 }}>
        <Typography
          component='span'
          sx={{
            fontSize: '0.6875rem',
            color: 'text.secondary',
            fontFamily: 'monospace',
            bgcolor: 'action.hover',
            px: 0.75,
            py: 0.25,
            borderRadius: '4px',
            fontWeight: 500,
            flexShrink: 0,
          }}
        >
          {formatItemIndex(index, currentPage, itemsPerPage)}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'text.primary',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={jobTitle.label}
        >
          {jobTitle.label}
        </Typography>
      </Box>
      <IconButton
        className='delete-btn'
        size='small'
        onClick={() => onDelete(jobTitle)}
        sx={{
          opacity: 0,
          transition: 'opacity 0.2s ease',
          color: 'text.secondary',
          '& svg': { width: 16, height: 16 },
          '&:hover': {
            color: 'error.main',
            bgcolor: 'error.lighter',
          },
        }}
        title='Delete'
        aria-label={`Delete job title ${jobTitle.label}`}
      >
        <SubtractCircleIcons />
      </IconButton>
    </Paper>
  );
};
